import React from 'react'
import Checkbox from 'components/input/checkbox'

export default ({
    label,
    onChange,
    value
}) => {
    return (
        <label className={'checkbox-item'}>
            <Checkbox
			    onChange={onChange}
			    isChecked={!!value}
            />
            <span dangerouslySetInnerHTML={{ __html: label }} />
        </label>
    )
}


// WEBPACK FOOTER //
// ./src/components/input/checkbox-item.jsx